import React from "react";
import ChatBot from "./ChatBot";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../Breadcrumb";

export default function LiveChatPage() {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <MasterLayout>
      <Breadcrumb title="Live Chat" />
      <div className="row gy-4">
        <ChatBot user={user} />
      </div>
    </MasterLayout>
  );
}
